export const CONVERSION_TIME_SPAN = 30
